import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import PageSkeleton from '../../components/PageSkeleton';
import LoadingPageError from '../../components/LoadingPageError';
const CertificationOverviewPageLoadable = Loadable({
  loader: () => import( /* webpackChunkName: "CertificationOverviewPage" */'../CertificationOverviewPage'),
  LoadingComponent: PageSkeleton,
  ErrorComponent: LoadingPageError
});
export default CertificationOverviewPageLoadable;